import { Method } from 'axios';

import { OnRequestFulfilled } from '@libs/axios/types';

import authService from '@app/libs/auth/authService';

import {
  create401HTTPResponseError,
  createHTTPHeaders,
  createIEBrowserCacheDisabledParam,
  getJSONWebToken,
  isExistJSONWebToken,
} from '../utils';

/**
 * 모두싸인 API에 대한 요청일 경우 필요한 헤더값을 추가해주는 interceptor
 */
export const onFulfilled: OnRequestFulfilled = async ({ credentials = true, ...config }) => {
  let token: string | null = null;

  if (credentials) {
    if (!isExistJSONWebToken(config.jwt)) {
      const error = create401HTTPResponseError('authorization token not found');
      return Promise.reject(Object.assign(error, { config }));
    }
    if (!config.jwt) {
      await authService.refreshTokens();
    }
    token = getJSONWebToken(config.jwt);
  }

  return {
    ...config,
    headers: createHTTPHeaders(
      config.headers,
      config.url,
      credentials,
      token as string,
      config.baseURL
    ),
    params: createIEBrowserCacheDisabledParam(
      config.method as Method,
      config.params,
      config.disableIEBrowserCache
    ),
  };
};
